import { render, staticRenderFns } from "./clinicBox.vue?vue&type=template&id=1216006b&scoped=true"
import script from "./clinicBox.vue?vue&type=script&lang=js"
export * from "./clinicBox.vue?vue&type=script&lang=js"
import style0 from "./clinicBox.vue?vue&type=style&index=0&id=1216006b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1216006b",
  null
  
)

export default component.exports